













































































































































































































































































































































































import { EmployeeType, TimeOffStateEnum } from '@/models';
import { ErrorManager } from '@/models/error';

import { mapActions, mapGetters } from 'vuex';
import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import HRDepartmentPicker from '../employee/hr/HRDepartmentPicker.vue';
import EmployeeTeamDepartmentPicker from '../employee/hr/EmployeeTeamDepartmentPicker.vue';
import CountryPicker from '@/components/common/CountryPicker.vue';
import EmployeePicker from '../employee/EmployeePicker.vue';

import DatePicker from '../common/DatePicker.vue';
import ErrorAlert from '../common/ErrorAlert.vue';

import { IFetchTimeOffRequestPayload } from '@/services/timeoff-request';
import { getPropertyFromItem } from '@/utils/helpers';

const baseMixins = mixins(auth);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    employeeSearchPicker: InstanceType<typeof EmployeePicker>;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'TimeOffRequestSearchFilter',

    components: {
      HRDepartmentPicker,
      CountryPicker,
      EmployeePicker,
      DatePicker,
      ErrorAlert,
      EmployeeTeamDepartmentPicker
    },

    props: {
      open: {
        type: Boolean,
        default: false
      },
      filterDateRange: {
        type: Boolean,
        default: false
      },

      canFilterEmployee: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        filterParams: {} as Partial<IFetchTimeOffRequestPayload>,

        isFilterValid: false,

        stateList: [
          {
            value: TimeOffStateEnum.Submitted,
            display_name: 'Waiting for approval'
          },
          {
            value: TimeOffStateEnum.Cancelled,
            display_name: TimeOffStateEnum[TimeOffStateEnum.Cancelled]
          },
          {
            value: TimeOffStateEnum.Rejected,
            display_name: TimeOffStateEnum[TimeOffStateEnum.Rejected]
          },
          {
            value: TimeOffStateEnum.Approved,
            display_name: TimeOffStateEnum[TimeOffStateEnum.Approved]
          }
        ],

        employeeTypeList: [
          {
            value: EmployeeType.Hourly,
            display_name: 'Hourly'
          },
          {
            value: EmployeeType.Salary,
            display_name: 'Salary'
          }
        ],

        timeOffTypePickerLoading: false,
        typePickerErrorMessage: '',

        errorMessage: '',
        detailErrorMessage: '',
        loading: false
      };
    },

    computed: {
      ...mapGetters({
        getTimeOffTypes: 'timeOff/getTimeOffTypes',
        getEmployeeById: 'employee/getEmployeeById'
      }),

      openValue: {
        get(): boolean {
          return this.open;
        },
        set(val: boolean) {
          if (val === this.open) return;
          this.$emit('update:open', val);
        }
      },

      startDateRangeRule() {
        return (start: any) => (end?: Date | string) => {
          if (!start || !end) return true;
          const startDate = new Date(start).valueOf();
          const endDate = new Date(end).valueOf();
          return startDate > endDate || 'Start cannot be greater than end';
        };
      },

      endDateRangeRule() {
        return (end: Date | string | null) => (start?: Date | string) => {
          if (!start || !end) return true;
          const startDate = new Date(start).valueOf();
          const endDate = new Date(end).valueOf();
          return startDate > endDate || 'End cannot be less than start';
        };
      }
    },

    methods: {
      ...mapActions({
        fetchAvailableTimeOffTypes: 'timeOff/fetchAvailableTimeOffTypes',
        fetchEmployee: 'employee/fetchEmployee'
      }),

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
      },

      fetchTimeOffTypes() {
        this.timeOffTypePickerLoading = true;

        this.fetchAvailableTimeOffTypes()
          .catch(error => {
            this.typePickerErrorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => (this.timeOffTypePickerLoading = false));
      },

      clearTypePickerError() {
        this.typePickerErrorMessage = '';
      },

      closeSearchFilterDialog() {
        this.openValue = false;

        // reset filter params back to empty object
        this.resetFilterParams();
      },

      resetFilterParams() {
        this.filterParams = {};
        this.clearAllErrors();
      },

      async openSearchFilterDialog(params: IFetchTimeOffRequestPayload) {
        this.clearAllErrors();

        if (params.type) {
          this.filterParams.type = Number(params.type);
        }

        // state can have a valid value of `0`
        if (params.state != null) {
          this.filterParams.state = Number(params.state);
        }

        if (params.employee && this.canFilterEmployee) {
          this.filterParams.employee = Number(params.employee);
          if (!this.getEmployeeById) {
            await this.fetchEmployee(params.employee);
          }
        }

        if (params.employee__type != null && this.canFilterEmployee) {
          this.filterParams.employee__type = Number(params.employee__type);
        }

        if (params.employee__hr_department) {
          if (
            this.isUserHRPersonnel ||
            this.isUserTimeOffReviewer ||
            this.userHasRoles([
              'Director',
              'Vice President',
              'Finance Vice President'
            ])
          ) {
            this.filterParams.employee__hr_department = Number(
              params.employee__hr_department
            );
          }
        }

        if (params.employee__location != null) {
          this.filterParams.employee__location = params.employee__location;
        }

        if (this.filterDateRange) {
          this.filterParams.start = params.start;
          this.filterParams.end = params.end;
        }

        this.fetchTimeOffTypes();

        const getEmployeeName = getPropertyFromItem(
          this.getEmployeeById,
          'fullName',
          ''
        );
        this.openValue = true;
        this.$nextTick(() => {
          const employeeSearchPicker = this.$refs.employeeSearchPicker;
          // wait for employee picker to mount
          if (employeeSearchPicker) {
            employeeSearchPicker.debouncefetchEmployees(getEmployeeName);
          }
        });
      },

      save() {
        const filters = this.filterParams;
        if (filters.employee) {
          delete filters.employee__type;
        }

        if (
          this.isUserHRPersonnel ||
          this.isUserTimeOffReviewer ||
          this.userHasRoles([
            'Director',
            'Vice President',
            'Finance Vice President'
          ])
        ) {
          // if there are any other filters and user is hr or timeoff reviewer then add all true param
          if (Object.values(filters).some(v => !!v)) {
            this.filterParams.all = 'true';
          }
        }

        this.$emit('change', this.filterParams);
        this.closeSearchFilterDialog();
      }
    }
  });
